import React from 'react';
import './CreditStoreModal.css';

const CREDIT_STORE_IMAGE_DIRECTORY = '/images';
const SAFE_IMAGE_FILENAME = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;

const formatPrice = (value) => {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return '';
  }

  return `$${numericValue.toFixed(2)}`;
};

const getBundleImageFilename = (bundle) => {
  if (typeof bundle.image_filename === 'string') {
    const trimmedFilename = bundle.image_filename.trim();

    if (trimmedFilename && SAFE_IMAGE_FILENAME.test(trimmedFilename)) {
      return trimmedFilename;
    }
  }

  const creditAmount = Number(bundle.credit_amount);

  if (creditAmount === 5) {
    return 'poker-chips-credits-05.png';
  }

  if (creditAmount === 12 || creditAmount === 26) {
    return `poker-chips-credits-${creditAmount}.png`;
  }

  return null;
};

const getBundleImageSrc = (bundle) => {
  const imageFilename = getBundleImageFilename(bundle);
  return imageFilename ? `${CREDIT_STORE_IMAGE_DIRECTORY}/${imageFilename}` : null;
};

const CreditStoreModal = ({
  visible = false,
  creditBalance = 0,
  creditBundles = [],
  loading = false,
  purchasingItemId = null,
  onPurchase,
  onClose,
}) => {
  if (!visible) {
    return null;
  }

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget && !loading) {
      onClose?.();
    }
  };

  return (
    <div className="cq-credit-store-overlay" onClick={handleOverlayClick} role="dialog" aria-modal="true" aria-label="Buy credits">
      <div className="cq-credit-store-modal">
        <button
          type="button"
          className="cq-credit-store-modal__close"
          onClick={() => onClose?.()}
          disabled={loading}
          aria-label="Close buy credits dialog"
        >
          x
        </button>

        <div className="cq-credit-store-modal__eyebrow">Wallet Refill</div>
        <h2 className="cq-credit-store-modal__title">Buy Credits</h2>
        <p className="cq-credit-store-modal__subtitle">
          Current balance: <strong>{creditBalance}</strong> credits
        </p>

        <div className="cq-credit-store-grid">
          {creditBundles.map((bundle) => {
            const isPurchasing = purchasingItemId === bundle.id;
            const imageSrc = getBundleImageSrc(bundle);

            return (
              <button
                key={bundle.id}
                type="button"
                className="cq-credit-bundle-card"
                onClick={() => onPurchase?.(bundle.id)}
                disabled={loading}
              >
                <span className="cq-credit-bundle-card__content">
                  <span className="cq-credit-bundle-card__credits">{bundle.credit_amount} Credits</span>
                  <span className="cq-credit-bundle-card__price">{formatPrice(bundle.price_usd)}</span>
                  <span className="cq-credit-bundle-card__description">
                    {bundle.description || 'Instantly top up your session wallet.'}
                  </span>
                  <span className="cq-credit-bundle-card__cta">
                    {isPurchasing ? 'Redirecting...' : 'Buy Bundle'}
                  </span>
                </span>
                {imageSrc ? (
                  <span className="cq-credit-bundle-card__art" aria-hidden="true">
                    <img src={imageSrc} alt="" loading="lazy" />
                  </span>
                ) : null}
              </button>
            );
          })}
        </div>

        {!creditBundles.length ? (
          <div className="cq-credit-store-empty">No credit bundles are available right now.</div>
        ) : null}
      </div>
    </div>
  );
};

export default CreditStoreModal;
